"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_CLOSE_WEB_SOCKET_CODE = exports.APP_ERROR_WEB_SOCKET_CODE = void 0;
exports.generateCode = generateCode;
exports.APP_ERROR_WEB_SOCKET_CODE = 4332;
exports.USER_CLOSE_WEB_SOCKET_CODE = 4333;
const ERROR_MESSAGE = "Error generating code. Check the Developer Console AND the backend logs for details.";
const CANCEL_MESSAGE = "Code generation cancelled";
function generateCode(wsRef, params, onChange, onSetCode, onStatusUpdate, onCancel, onComplete) {
    var _a;
    // const wsUrl = `${WS_BACKEND_URL}/generate-code`;
    const wsUrl = (_a = process.env.EMAIL_GENERATION_WEBSOCKET) !== null && _a !== void 0 ? _a : "wss://dev.crm.sc.marktine.com/generate-code";
    const wsVersion = process.env.EMAIL_GENERATION_WEBSOCKET_VERSION;
    console.log('🔌 Connecting to WebSocket:', wsUrl);
    console.log('📤 Sending params:', params);
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;
    ws.addEventListener("open", () => {
        console.log('✅ WebSocket connected successfully with version', wsVersion);
        ws.send(JSON.stringify(Object.assign(Object.assign({}, params), { version: wsVersion })));
        console.log('📤 Sent params to WebSocket');
    });
    ws.addEventListener("message", (event) => __awaiter(this, void 0, void 0, function* () {
        console.log('📨 Received WebSocket message:', event.data);
        try {
            const response = JSON.parse(event.data);
            console.log('📋 Parsed response:', response);
            if (response.type === "chunk") {
                console.log('📝 Processing chunk:', response.value);
                onChange(response.value, response.variantIndex);
            }
            else if (response.type === "status") {
                console.log('📊 Processing status:', response.value);
                onStatusUpdate(response.value, response.variantIndex);
            }
            else if (response.type === "setCode") {
                console.log('📋 Processing setCode:', response.value.length, 'characters');
                onSetCode(response.value, response.variantIndex);
            }
            else if (response.type === "error") {
                console.error("❌ WebSocket error response:", response.value);
                // toast.error(response.value);
            }
        }
        catch (error) {
            console.error('❌ Error parsing WebSocket message:', error);
            console.error('Raw message:', event.data);
        }
    }));
    ws.addEventListener("close", (event) => {
        console.log("🔌 WebSocket connection closed:", event.code, event.reason);
        if (event.code === exports.USER_CLOSE_WEB_SOCKET_CODE) {
            console.log("🛑 User cancelled code generation");
            alert(CANCEL_MESSAGE);
            // toast.success(CANCEL_MESSAGE);
            onCancel();
        }
        else if (event.code === exports.APP_ERROR_WEB_SOCKET_CODE) {
            console.error("❌ Known server error", event);
            onCancel();
        }
        else if (event.code !== 1000) {
            console.error("❌ Unknown server or connection error", event);
            alert(ERROR_MESSAGE);
            // toast.error(ERROR_MESSAGE);
            onCancel();
        }
        else {
            console.log("✅ WebSocket closed normally");
            onComplete();
        }
    });
    ws.addEventListener("error", (error) => {
        console.error("❌ WebSocket error:", error);
        alert(ERROR_MESSAGE);
        // toast.error(ERROR_MESSAGE);
    });
}
